import {action, computed} from "easy-peasy";
import Pusher from "pusher-js";


export const PUSHER_EVENTS_TYPES = {
    REFETCH_MOVIE: 0x1,
    MOVIE_TRAILER_LOGS: 0x2,
    REFETCH_SCENE: 0x3,
    SCENE_LOGS: 0x4,
    SCENE_THUMBNAIL_LOGS: 0x5,
    SCENE_THUMBNAIL_VIDEO_LOGS: 0x6,
    MOVIE_LOGS: 0x7,
}

export const pusherModel = {
    lastEvent: null,
    events: [],
    setEvent: action((state, payload) => {
        state.lastEvent = payload;
        state.events = [...state.events, {
            ...payload,
            eventId: new Date().getTime(),
        }];
    }),
    initPusher: action((actions) => {
        const pusher = new Pusher('782765ca07a40d8fa82c', {
            cluster: 'eu'
        })

        const channel = pusher.subscribe('admin-channel');

        channel.bind('admin.message.sent', (data) => {
            actions.setEvent(data);
        })
    }),
    getEventsByType: computed((state) => {
        return (type) => state?.events?.filter(event => +event.type === +type)
    }),
    processEvent: action((state, payload) => {
        const events = [...state.events];
        const index = events.findIndex((event) => event.eventId === payload.eventId);
        if(index === -1) return;
        events.splice(index, 1);
        state.events = [...events];
    }),
    processEvents: action((state, payload) => {
        const idsToRemove = new Set(payload.map(event => event.eventId));
        state.events = state.events.filter(event => !idsToRemove.has(event.eventId));
    })
}